import { FadeIn, FadeOut } from "appworks/graphics/animation/base-animations";
import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";

const FADE_IN_DURATION: number = 350;
const FADE_OUT_DURATION: number = 350;

export class TGRInstantWinsSceneTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        const text: Text = this.layer.getText("value");
        text.text = "";
        const infoPanel: Sprite = this.layer.getSprite("info_panel");

        return new Parallel([
            () => FadeIn(infoPanel, FADE_IN_DURATION),
            () => FadeIn(text, FADE_IN_DURATION)
        ]);
    }

    public out(): Contract<void> {
        const text: Text = this.layer.getText("value");
        const infoPanel: Sprite = this.layer.getSprite("info_panel");

        return new Parallel([
            () => FadeOut(infoPanel, FADE_OUT_DURATION),
            () => FadeOut(text, FADE_OUT_DURATION)
        ]);
    }
}
